import React from 'react';
import { Link } from 'react-router-dom';
import logo_footer_clean from '../../assests/images/logo_footer_clean.png';
import VisitorCounter from './VisitorCounter';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="tw-bg-slate-900 tw-text-slate-200 pt-5 pb-4" aria-label="Footer">
      <div className="container">
        <div className="row gy-4 align-items-start">

          {/* Brand statement column */}
          <div className="col-lg-3 col-md-6">
            <Link to="/" aria-label="Seikural Innovation — Home" className="text-decoration-none d-inline-block mb-3">
              <img
                src={logo_footer_clean}
                alt="Seikural Innovation Pvt. Ltd."
                loading="lazy"
                decoding="async"
                className="sipl-footer-logo"
              />
            </Link>
            <p className="fw-semibold text-white mb-1" style={{ fontSize: '0.95rem' }}>
              Seikural Innovation Pvt. Ltd.
            </p>
            <p className="tw-text-slate-400" style={{ fontSize: '0.875rem', lineHeight: '1.6' }}>
              Technology and digital solutions for businesses building what comes next.
            </p>
          </div>

          {/* Contact / Address */}
          <div className="col-lg-3 col-md-6">
            <h6 className="fw-semibold tw-text-white mb-3 text-uppercase" style={{ fontSize: '0.75rem', letterSpacing: '0.08em' }}>
              Visit Us
            </h6>
            <p className="tw-text-slate-400 mb-2" style={{ fontSize: '0.875rem', lineHeight: '1.7' }}>
              No. 10, Shankar Layout, GN Mills,<br />
              Coimbatore - 641029
            </p>
            <ul className="list-unstyled mb-0 d-flex flex-column gap-2">
              <li>
                <a href="mailto:info@seikural.com" className="tw-text-slate-400 hover:tw-text-teal-400 text-decoration-none" style={{ fontSize: '0.875rem', transition: 'color 0.2s' }}>
                  info@seikural.com
                </a>
              </li>
              <li>
                <a href="tel:+919751836710" className="tw-text-slate-400 hover:tw-text-teal-400 text-decoration-none" style={{ fontSize: '0.875rem', transition: 'color 0.2s' }}>
                  +91 97518 36710
                </a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div className="col-lg-2 col-md-3 col-6">
            <h6 className="fw-semibold tw-text-white mb-3 text-uppercase" style={{ fontSize: '0.75rem', letterSpacing: '0.08em' }}>
              Company
            </h6>
            <ul className="list-unstyled mb-0 d-flex flex-column gap-2">
              {[
                { label: 'About Us', to: '/about' },
                { label: 'Careers', to: '/careers' },
                { label: 'Industries', to: '/industries' },
                { label: 'Contact', to: '/contact' },
              ].map(({ label, to }) => (
                <li key={label}>
                  <Link
                    to={to}
                    className="tw-text-slate-400 hover:tw-text-teal-400 text-decoration-none"
                    style={{ fontSize: '0.875rem', transition: 'color 0.2s' }}
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="col-lg-3 col-md-3 col-6">
            <h6 className="fw-semibold tw-text-white mb-3 text-uppercase" style={{ fontSize: '0.75rem', letterSpacing: '0.08em' }}>
              Services
            </h6>
            <ul className="list-unstyled mb-0 d-flex flex-column gap-2">
              {[
                { label: 'Web & Application Development', to: '/services/web-development' },
                { label: 'Business Software Solutions', to: '/services/business-software' },
                { label: 'UI/UX & Product Design', to: '/services/ui-ux-design' },
                { label: 'Cloud & DevOps', to: '/services/cloud-devops' },
                { label: 'Digital Marketing', to: '/services/digital-marketing' },
              ].map(({ label, to }) => (
                <li key={label}>
                  <Link
                    to={to}
                    className="tw-text-slate-400 hover:tw-text-teal-400 text-decoration-none"
                    style={{ fontSize: '0.875rem', transition: 'color 0.2s' }}
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

        </div>

        {/* Divider + footer meta */}
        <hr className="mt-5 mb-3" style={{ borderColor: 'rgba(148,163,184,0.15)' }} />
        <div className="d-flex flex-column flex-sm-row align-items-center justify-content-between gap-2">
          <p className="tw-text-slate-500 mb-0 text-center text-sm-start" style={{ fontSize: '0.8rem' }}>
            © {currentYear} Seikural Innovation Pvt. Ltd. All rights reserved.
          </p>

          <div className="flex-grow-1 d-flex justify-content-center">
            <VisitorCounter />
          </div>

          <p className="tw-text-slate-600 mb-0 text-center text-sm-end" style={{ fontSize: '0.8rem' }}>
            Technology & Digital Solutions for Business Growth
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;